module.exports = __webpack_public_path__ + "static/media/4.0f8ca81e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/4.jpg
// module id = 26
// module chunks = 0